import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
function useOrderDetail(id, params) {
  return useSWR(
    !!id
      ? {
          path: `/api/v1/orders/${id}`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useOrderDetail;
